import { Modal, ModalBody, ModalHeader, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { PetitionReportAbuseForm } from '../components/PetitionReportAbuseForm';
import type { ReportContext } from '../shared/types';

import { ReportAbuseFormContainer } from './ReportAbuseForm';

export const ReportAbuseModal: React.FC<ReportAbuseModalProps> = ({
	isOpen,
	onOpenChange,
	onSuccess,
	v2,
	reportContext,
	onClose = () => {},
}) => {
	return (
		<Modal isOpen={isOpen} onOpenChange={onOpenChange} onClose={onClose} className="z-2010">
			<ModalHeader
				title={
					<Text variant="heading" fontWeight="bold" size="small">
						<Translate value="fe.components.petition_report_abuse.form_title" />
					</Text>
				}
			/>
			<ModalBody className="px-2">
				<Header />
				{reportContext.type === 'petition' && v2 ? (
					<PetitionReportAbuseForm onSuccess={onSuccess} {...reportContext} />
				) : (
					<ReportAbuseFormContainer onSuccess={onSuccess} {...reportContext} />
				)}
				<Footer type={reportContext.type} />
			</ModalBody>
		</Modal>
	);
};

type ReportAbuseModalProps = Readonly<{
	isOpen: boolean;
	onOpenChange: (isOpen: boolean) => void;
	onSuccess?: () => void;
	v2?: boolean;
	reportContext: ReportContext;
	onClose?: () => void;
}>;
